import { EERIE, OLAF, PANTERA } from 'HubStyleTokens/colors';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UICloseButton from 'UIComponents/button/UICloseButton';
import UILoadingButton from 'UIComponents/button/UILoadingButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useCallback, useState } from 'react';
import styled from 'styled-components';
import FeedbackTooltipDetail from './FeedbackTooltipDetail';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const SelectableUIIcon = styled(UILoadingButton).withConfig({
  displayName: "SentimentButtonWithTooltip__SelectableUIIcon",
  componentId: "sc-3bggnc-0"
})(["padding:9px 8px 7px 8px !important;background:", " !important;color:", " !important;border:none !important;margin:0 !important;"], ({
  selected
}) => selected ? PANTERA : 'inherit', ({
  selected
}) => selected ? OLAF : 'inherit');
export default function SentimentButtonWithTooltip({
  iconName,
  sentiment,
  handleSentimentChange,
  selectedSentiment,
  submitFeedback,
  isLoading,
  isSubmitted,
  feedbackProps
}) {
  const isSelected = selectedSentiment === sentiment;
  useState([]);
  const onClose = useCallback(() => handleSentimentChange(null), [handleSentimentChange]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [feedbackText, setFeedbackText] = useState('');
  const onSubmit = useCallback(() => submitFeedback({
    sentiment,
    selectedCategories,
    feedbackText
  }), [feedbackText, selectedCategories, sentiment, submitFeedback]);
  return /*#__PURE__*/_jsx(UITooltip, {
    use: "longform",
    open: isSelected && !isSubmitted && !isLoading,
    headingText: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(View, {
        marginInlineEnd: "500",
        as: "div",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `messaging-insights.insights.feedback.tooltipHeader.${sentiment}`
        })
      }), /*#__PURE__*/_jsx(UICloseButton, {
        onClick: onClose,
        color: EERIE,
        size: "md"
      })]
    }),
    title: /*#__PURE__*/_jsx(FeedbackTooltipDetail, {
      sentiment: sentiment,
      handleCategoryChange: setSelectedCategories,
      selectedCategories: selectedCategories,
      onClose: onClose,
      onSubmit: onSubmit,
      onFeedbackTextChange: setFeedbackText,
      feedbackText: feedbackText,
      feedbackProps: feedbackProps
    }),
    children: /*#__PURE__*/_jsx(SelectableUIIcon, {
      use: "tertiary-extra-light",
      onClick: () => handleSentimentChange(isSelected ? null : sentiment),
      selected: isSelected,
      size: "sm",
      loading: isSelected && isLoading,
      children: /*#__PURE__*/_jsx(UIIcon, {
        size: "xxs",
        name: iconName
      })
    })
  });
}